import React, {useEffect, useRef} from 'react';
import ChatUtils from "../../utils/chat-utils.js";
import {FaPlay} from "react-icons/fa";

const ChatMessage = ({message, setImageModal, setVideoModal, history = false}) => {
    const liRef = useRef(null);

    const isSelf = !(message.u?.username && message.u.username.endsWith("citizen"));
    const text = message.msg;
    const attachment = message.attachments?.[0];
    const sourceUrl = attachment ? ChatUtils.getResourceUrl(attachment.title_link, history) : null;
    const time = ChatUtils.getMessageTime(message);

    useEffect(() => {
        if (liRef.current?.parentElement) {
            const parent = liRef.current.parentElement;
            parent.scrollTop = parent.scrollHeight;
        }
    }, []);

    function renderAttachment(att, message, sourceUrl) {
        const file = message.file;

        if (!file || !att) return null;

        if (att.image_type) {
            const imageClick = () => {
                if (setImageModal) setImageModal({open: true, imgSrc: sourceUrl})
            }

            return (
                <img
                    src={sourceUrl}
                    className="msg-img py-3"
                    onClick={imageClick}
                    style={{ cursor: "pointer" }}
                />
            );
        }

        if (att.video_type) {
            const videoClick = () => {
                if (setVideoModal) setVideoModal({open: true, videoSrc: sourceUrl})
            }

            return (
                <div className="video-wrapper">
                    <div className="video-overlays" onClick={videoClick}>
                        <FaPlay />
                    </div>
                    <video id={`${message._id}-video`}>
                        <source src={sourceUrl} type="video/mp4" />
                    </video>
                </div>
            );
        }

        if (att.audio_type) {
            return (
                <audio controls>
                    <source src={sourceUrl} />
                </audio>
            );
        }

        return null;
    }

    return (
        <li ref={liRef} className={isSelf ? "self" : ""}>
            <div className={`msg ${isSelf ? "self" : ""} p-1`}>
                {text && <div className="msg-body wrap-break-word">{text}</div>}

                {attachment && renderAttachment(attachment, message, sourceUrl)}

                {time && <span className="msg-time">{time}</span>}
            </div>
        </li>
    );
};

export default ChatMessage;